import React from 'react';
import { FormattedMessage } from 'react-intl';
import { LawFirmsRepresentingEnterprise } from './LawFirmsRepresentingEnterprise';
import { LawyersRepresentingEnterprise } from './LawyersRepresentingEnterprise';
import { withEnterprise } from './EnterpriseContext';
import { EnterpriseContextType } from './enterprise.types';

type Props = EnterpriseContextType;

type State = {
  shouldDisplayTitle: boolean;
};

export class RawEnterpriseRepresenting extends React.Component<Props, State> {
  id = 'enterprise-representing';

  state: State = {
    shouldDisplayTitle: false,
  };

  displayTitle = () => {
    this.setState({ shouldDisplayTitle: true }, () => {
      window.dispatchEvent(
        new CustomEvent('createNav', {
          detail: this.id,
        }),
      );
    });
  };

  render() {
    const {
      enterpriseInfos: { raisonSociale },
    } = this.props;
    const { shouldDisplayTitle } = this.state;
    return (
      <>
        {shouldDisplayTitle && (
          <h2 id={this.id} className="entity__section-title">
            <FormattedMessage
              id="app.pages.enterprise.representing.title"
              values={{ enterpriseName: raisonSociale }}
            />
          </h2>
        )}
        <LawFirmsRepresentingEnterprise displayTitle={this.displayTitle} />
        <LawyersRepresentingEnterprise displayTitle={this.displayTitle} />
      </>
    );
  }
}

export const EnterpriseRepresenting = withEnterprise(RawEnterpriseRepresenting);
